module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (36).295bfcfc.png";